<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-信息录入-修改
    -->
    <el-dialog
    title="修改信息录入"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改信息录入</div>
      <!-- 全分类选择 -->
      <!-- <el-form-item label="选择全分类" prop="name" >
            <div>{{ form.categorya.name }}</div>
        
          <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为信息录入标题</el-button>
        </el-form-item> -->

        <el-form-item label="信息录入名称" prop="name"><el-input v-model="form.name" placeholder="请输入信息录入名称" class="max-w460"></el-input></el-form-item>
        <el-form-item label="身份类型" prop="categories" required>
        <el-radio-group v-model="form.categories" @change="handleCategoryChange">
          <el-radio :label="1">医生</el-radio>
          <el-radio :label="2">患者</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="信息录入名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入信息录入名称" class="max-w460"></el-input>
      </el-form-item>
    
      <!-- 医生专属字段 -->
      <div v-if="form.categories === 1">
        <el-form-item label="拜访日期" prop="visit_date">
          <el-date-picker v-model="form.visit_date" type="date" placeholder="选择拜访日期"   value-format="yyyy-MM-dd HH:mm:ss" class="max-w460"></el-date-picker>
        </el-form-item>
        
        <el-form-item label="拜访内容" prop="visit_content">
          <el-input v-model="form.visit_content" type="textarea" :rows="3" placeholder="请输入拜访内容" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="后续计划日期" prop="plan_date">
          <el-date-picker v-model="form.plan_date" type="date" placeholder="选择后续计划日期"    class="max-w460"></el-date-picker>
        </el-form-item>
      </div>

      <!-- 患者专属字段 -->
      <div v-if="form.categories === 2">
        <el-form-item label="记录时间" prop="record_time">
          <el-date-picker v-model="form.record_time" type="datetime" placeholder="记录时间"   value-format="yyyy-MM-dd HH:mm:ss" class="max-w460"></el-date-picker>
        </el-form-item>
        
        <el-form-item label="手术日期" prop="surgery_date">
          <el-date-picker v-model="form.surgery_date" type="date" placeholder="选择手术日期"   class="max-w460"></el-date-picker>
        </el-form-item>
        
        <el-form-item label="状况描述" prop="condition">
          <el-input v-model="form.condition" type="textarea" :rows="3" placeholder="请输入患者状况描述" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入备注信息" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="取出日期" prop="remove_date">
          <el-date-picker v-model="form.remove_date" type="date" placeholder="选择取出日期"   class="max-w460"></el-date-picker>
        </el-form-item>
      </div>
       
  

<!-- 
      <el-form-item label="信息录入bannar：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.bannar">
          <transition-group>
            <div v-for="(item, index) in form.bannar" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('bannar')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>


      <el-form-item label="信息录入图片：" prop="model.image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item> -->

     
    <el-form-item label="信息录入介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
  </div>
</el-dialog>
  
</template>

<script>
import EntryApi from '@/api/entry.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        categories: null, // 身份类型：1-医生，2-患者
        name: '',
        code: 'custom',
        // categorya:{
        //   name:""
        // },
      //  image:[],
        sort:50,
        intro:"",
      //  bannar:[]
       // 医生专属字段
        visit_date: '',
        visit_content: '',
        plan_date: '',
        
        // 患者专属字段
        record_time: '',
        surgery_date: '',
        condition: '',
        remark: '',
        remove_date: null






      },
      loading: false,
      /*验证规则*/
       rules: {
        name: [{ required: true, message: '请输入信息录入名称', trigger: 'blur' }],
        categories: [{ required: true, message: '请选择身份类型', trigger: 'change' }],
        visit_date: [{ required: true, message: '请选择拜访日期', trigger: 'change' }],
        visit_content: [{ required: true, message: '请输入拜访内容', trigger: 'blur' }],
        record_time: [{ required: true, message: '请选择记录时间', trigger: 'change' }],
        surgery_date: [{ required: true, message: '请选择手术日期', trigger: 'change' }],
        condition: [{ required: true, message: '请输入状况描述', trigger: 'blur' }]
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album"
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","entry_id"],
  methods: {
     handleCategoryChange() {
      // 切换身份类型时，可以清空另一身份的字段（可选）
      if (this.form.categories === 1) {
        // 选择医生，清空患者字段
        this.form.record_time = null;
        this.form.surgery_date = null;
        this.form.condition = '';
        this.form.remark = '';
        this.form.remove_date = null;
      } else if (this.form.categories === 2) {
        // 选择患者，清空医生字段
        this.form.visit_date = null;
        this.form.visit_content = '';
        this.form.plan_date = null;
      }
    },
    // closeDialogFunc(e) {
    //   console.log(e)
    //   let self = this;
    //   self.iscategorya = false;
    //   if (e.type === 'success') {
    //     let arr = [];
    //     for (let i = 0; i < e.params.length; i++) {
    //       let item = e.params[i];
    //       arr = {
    //         name: item.name,
    //         categorya_id: item.categorya_id,
    //         image: item.image,
    //       };
    //     }
    //     self.form.categorya = arr;
    
    //   }
    // },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      EntryApi.detail({entry_id: self.entry_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      // if(form.image.length <=0){
      //   self.$message({
      //           message:"请上传图片",
      //           type: 'error'
      //         });
      //         return;
      // }
      form.entry_id = self.entry_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          EntryApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/entry/index/part/edit.vue